export const nullUser: Types.API.User.IUserInfo = {
  email: '',
  name: '',
  role: 'guest',
  school: { id: '', name: '' },
  phone: '',
  grade: '',
  id: '',
  active: false,
  loggedInBefore: false,
};
